<template>

<div class="content" :class="{'is-padded': isPadded, 'is-grown': isGrown, 'is-loading': isLoading}">

	<com-drag v-if="canReorder" v-model="order" :forceFallback="true" handle=".drag-handle" v-on:update="$emit('reordered', order)">

		<slot></slot>

	</com-drag>

	<template v-if="!canReorder">

		<slot></slot>

	</template>

	<app-icon icon="loading" class="content-loading" v-if="isLoading" />

	<div class="content-empty" v-if="isEmpty">
		<template v-if="!allowSearch">{{ emptyMessage }}</template>
		<input type="text" ref="search" v-model="search" :placeholder="emptyMessage" v-if="allowSearch" v-on:keydown.enter="onSearchSubmit" />
		<small v-if="allowSearch">Type search term and press enter</small>
	</div>

</div>

</template>

<script>

export default {

	props: ['isPadded', 'canReorder', 'isGrown', 'isLoading', 'isEmpty', 'allowSearch', 'emptyMessage'],

	components: {
		'com-drag': () => import('vuedraggable')
	},

	data: function() {

		return {
			order: [],
			search: ''
		}

	},

	created: function() {

		this.populateOrder()

	},

	watch: {

		canReorder: function() {

			this.populateOrder()

		}

	},

	methods: {

		onSearchSubmit: function() {

			this.$emit('search', this.search)

			this.search = ''

		},

		populateOrder: function() {

			this.order = this.$_.clone(this.canReorder)

		}

	}	

}

</script>

<style scoped>

.content {
	flex-grow: 1;
	z-index: 1;
	padding: 20px 0px 20px 0px;
	overflow-y: auto;
	display: flex;
    flex-direction: column;
}

.content.is-loading > *:not(.content-loading) {
	opacity: 0.5;
}

.content.is-padded {
	padding: 20px;
}

.content.is-grown {
	padding-bottom: 0px;
}

.content-empty {
	font-size: 24px;
	color: #ccc;
	font-weight: 400;
	position: absolute;
	left: 0%;
	width: 100%;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
}

.content-empty input {
	font-size: 24px;
	color: #666;
	font-weight: 400;
	text-align: center;
}

.content-empty input::placeholder {
	color: #ccc;
}

.content-empty small {
	font-size: 14px;
	margin-top: 10px;
	color: #ccc;
}

.content-loading {
	font-size: 96px;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	color: #4082d3;
}

</style>
